module.exports = __webpack_public_path__ + "img/sales.69669ff.jpg";